import { render, staticRenderFns } from "./HmnPrintCritical.vue?vue&type=template&id=68dd7ef4"
import script from "./HmnPrintCritical.vue?vue&type=script&lang=js"
export * from "./HmnPrintCritical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports